import i18next from "i18next";
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-chained-backend';
import resourcesToBackend from 'i18next-resources-to-backend'
import HttpBackend from 'i18next-http-backend';
import apiClient from "./apiClient";
import * as ApiURL from "../containers/APIurls";

const CLIENT_NAME = "react";

i18next
  .use(Backend)
  .use(initReactI18next)
  .init({
    debug: true,
    lng: "en-US",
    fallbackLng: false,
    load: "currentOnly",
    nsSeparator: false,
    interpolation: {
      escapeValue: false,
    },
    ns: [],
    partialBundledLanguages: true,
    react: {
      bindI18n: "languageChanged",
      bindI18nStore: "",
      useSuspense: true,
    },
    backend: {
      backends: [
        HttpBackend,
        // resourcesToBackend((language, namespace, callback) => {
        //   import(`../translations/${namespace}/en-us.json`)
        //   .then(({ default: resources }) => {
        //     callback(null, resources)
        //   })
        //   .catch((error) => {
        //     callback(error, null)
        //   })
        // })
      ],
      backendOptions: [
        {
          loadPath: 
              `${ApiURL.AEM_URL}?aem={{ns}}`,
          allowMultiLoading: true,
          request: async (options, url, payload, callback) => {
            try {
                const translation = await apiClient.get(url);
                callback(null, {
                    status: 200,
                    data: JSON.parse(translation.data),
                });
            } catch (e) {
              callback(e);
            }
          },
        }
      ]
    },
  });

export default i18next;
